function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "ic-folder"
}, "Folder");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.39575 4.25C2.39575 4.11193 2.50302 4 2.63534 4H8.33991C8.43732 4 8.52503 4.06154 8.56179 4.15568L9.23307 5.875H2.39575V4.25ZM2.63534 2.5C1.70911 2.5 0.958252 3.2835 0.958252 4.25V20.046C0.958252 20.5983 1.38731 21.046 1.91659 21.046H21.0833C21.6125 21.046 22.0416 20.5983 22.0416 20.046V7.05005C22.0416 6.49776 21.6125 6.05005 21.0833 6.05005H10.8536L9.89305 3.58973C9.63578 2.9308 9.02178 2.5 8.33991 2.5H2.63534ZM2.39575 19.546V7.55005H20.6041V19.546H2.39575Z"
});

function SvgIcFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolder);
export default __webpack_public_path__ + "static/media/ic_folder.e73c7cae48e8bcbbbd2d5a5d86d30b37.svg";
export { ForwardRef as ReactComponent };